import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
    title: string;
    actions?: ReactNode;
    children: ReactNode;
}

export default function PageWrapper({ title, actions, children }: Props) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                padding: '24px',
                boxSizing: 'border-box',
                backgroundColor: 'white',
                minHeight: '100%',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    flexWrap: 'wrap',
                }}
            >
                <Typography variant="h1">{title}</Typography>
                <Stack direction="row" spacing={1}>
                    {actions}
                </Stack>
            </Box>
            {children}
        </Box>
    );
}
